import { FeatureDefinition } from '../entities';

export const appnebulaPaymentRedirectFeature = 'appnebula_payment_redirect';

export type PaymentRedirectFeatureValue = {
  link: string;
};

export const paymentRedirectDefaultFeatureValue: PaymentRedirectFeatureValue = {
  link: '',
};

export const paymentRedirectFeatureConfig: FeatureDefinition<PaymentRedirectFeatureValue> = {
  defaultValue: paymentRedirectDefaultFeatureValue,
};
